module.exports = __webpack_public_path__ + "img/证书4.fb035ebc.jpg";